(function() {
  var MIN_CARDS = 2;
  var MAX_CARDS = 4;

  var _discountTiers = null;
  function getDiscountTiers() {
    if (_discountTiers) return _discountTiers;
    _discountTiers = [];
    var el = document.querySelector('[data-milestones]');
    if (!el) return _discountTiers;
    try {
      var milestones = JSON.parse(el.getAttribute('data-milestones'));
      milestones.forEach(function(m) {
        if (m.label && /\d+%/.test(m.label)) {
          var pct = parseInt(m.label.match(/(\d+)%/)[1], 10);
          _discountTiers.push({ threshold: m.threshold, percent: pct });
        }
      });
      _discountTiers.sort(function(a, b) { return b.threshold - a.threshold; });
    } catch(e) {}
    return _discountTiers;
  }

  function getDiscountPercent(projectedTotalCents) {
    // Disabled: don't show tier discount preview on upsell cards (messy with current sale)
    return 0;
  }

  var _cartSubtotalCents = 0;

  var CROSSSELL_MAP = {
    'Women Tops':        ['scrub-pants', 'women-jump-suits'],
    'Women Pants':       ['scrub-tops-women', 'jackets-women'],
    'Women Joggers':     ['scrub-tops-women', 'jackets-women'],
    'Women Jumpsuits':   ['jackets-women', 'underscrubs'],
    'Women Underscrubs': ['scrub-tops-women', 'scrub-pants'],
    'Men Tops':          ['scrub-pants-men', 'men-jackets'],
    'MEN PANTS':         ['men-scrub-top-1', 'men-jackets'],
    'Men Jackets':       ['men-scrub-top-1', 'scrub-pants-men'],
    'Men Underscrubs':   ['men-scrub-top-1', 'scrub-pants-men'],
    'HEADBAND':          ['scrub-tops-women', 'scrub-pants'],
    'Women Scrunchie':   ['scrub-tops-women', 'scrub-pants']
  };

  var FALLBACK_COLLECTIONS = [
    'scrub-tops-women', 'scrub-pants', 'men-scrub-top-1', 'scrub-pants-men',
    'jackets-women', 'men-jackets', 'women-jump-suits'
  ];

  var _cache = {};
  var _running = false;
  var _lastCartToken = '';
  var _renderedHTML = '';
  var _renderedProducts = [];
  var _renderedSiblings = {};

  function moneyFmt(cents) {
    var amount = (cents / 100).toFixed(2);
    var fmt = window.themeMoneyFormat || '';
    if (!fmt) return '$' + amount;
    return fmt.replace(/\{\{[^}]*amount[^}]*\}\}/g, amount);
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function getAllRoots() { return document.querySelectorAll('[data-cart-upsell-root]'); }
  function getAllContainers() { return document.querySelectorAll('[data-cart-upsell-cards]'); }

  async function fetchJSON(url, opts) {
    var r = await fetch(url, opts || {});
    if (!r.ok) throw new Error(r.status);
    return r.json();
  }

  function skeletonHTML() {
    var card = '<div class="cu__card cu__skel-card">' +
      '<div class="cu__card-check"><div class="cu__skel-box" style="width:15px;height:15px;border-radius:3px"></div></div>' +
      '<div class="cu__card-img"><div class="cu__skel-box" style="width:56px;height:56px;border-radius:4px"></div></div>' +
      '<div class="cu__card-body">' +
        '<div class="cu__skel-box" style="width:70%;height:11px;border-radius:3px"></div>' +
        '<div class="cu__skel-box" style="width:40%;height:11px;border-radius:3px;margin-top:4px"></div>' +
        '<div style="display:flex;gap:6px;margin-top:5px">' +
          '<div class="cu__skel-box" style="width:50%;height:24px;border-radius:4px"></div>' +
          '<div class="cu__skel-box" style="width:50%;height:24px;border-radius:4px"></div>' +
        '</div>' +
      '</div>' +
    '</div>';
    return card + card + card + card;
  }

  function showSkeleton() {
    var roots = getAllRoots();
    var containers = getAllContainers();
    roots.forEach(function(r) { r.hidden = false; });
    containers.forEach(function(c) { c.innerHTML = skeletonHTML(); });
    roots.forEach(function(r) {
      var footer = r.querySelector('.cu__footer');
      if (footer) footer.style.display = 'none';
    });
  }

  function showFooter() {
    getAllRoots().forEach(function(r) {
      var footer = r.querySelector('.cu__footer');
      if (footer) footer.style.display = '';
    });
  }

  function applyRenderedHTML() {
    if (!_renderedHTML) return;
    var containers = getAllContainers();
    var roots = getAllRoots();
    containers.forEach(function(c) {
      c.innerHTML = _renderedHTML;
      bindCardEvents(c);
    });
    roots.forEach(function(r) {
      r.hidden = false;
      showFooter();
      bindTotalListeners(r);
    });
  }

  function normalizeSwatchItem(item) {
    var imgs = item.image_urls || [];
    return {
      handle: item.handle,
      title: item.title || '',
      product_type: item.type || '',
      variants: item.variants || [],
      options: ['Size'],
      images: imgs.map(function(u) { return { src: u }; })
    };
  }

  async function tier1(cartHandles) {
    var handles = [];
    // Linked products are keyed by product HANDLE in the new API; enrich:true
    // hydrates each item with Shopify variants/type/images so add-to-cart works.
    var promises = cartHandles.filter(Boolean).map(function(handle) {
      return window.HealixColors.linkedProducts(handle, { enrich: true })
        .then(function(data) {
          var items = [].concat(data.wearit || [], data.complete || []);
          items.forEach(function(item) {
            var h = item.handle || '';
            if (!h) return;
            handles.push(h);
            var normalized = normalizeSwatchItem(item);
            var hasAvail = normalized.variants.some(function(v) { return v.available; });
            if (hasAvail && !_cache[h]) _cache[h] = normalized;
          });
        }).catch(function() {});
    });
    await Promise.all(promises);
    return handles;
  }

  async function tier2(productTypes) {
    var handles = [];
    var colSet = {};
    var cols = [];
    productTypes.forEach(function(pt) {
      var targets = CROSSSELL_MAP[pt];
      if (!targets) return;
      targets.forEach(function(col) {
        if (!colSet[col]) { colSet[col] = true; cols.push(col); }
      });
    });
    var promises = cols.map(function(col) {
      return fetchJSON('/collections/' + encodeURIComponent(col) + '/products.json?limit=8&sort_by=best-selling')
        .then(function(data) {
          (data.products || []).forEach(function(p) {
            var hasAvail = (p.variants || []).some(function(v) { return v.available; });
            if (hasAvail && p.handle) {
              handles.push(p.handle);
              _cache[p.handle] = p;
            }
          });
        }).catch(function() {});
    });
    await Promise.all(promises);
    return handles;
  }

  async function fetchProduct(handle) {
    if (_cache[handle]) return _cache[handle];
    try {
      var data = await fetchJSON('/products/' + encodeURIComponent(handle) + '.json');
      var p = data.product;
      if (p && p.variants) {
        p.variants.forEach(function(v) {
          if (typeof v.available === 'undefined') v.available = true;
        });
      }
      _cache[handle] = p;
      return p;
    } catch(e) { return null; }
  }

  async function fetchColorSiblings(handles) {
    if (!handles.length) return {};
    try {
      var data = await window.HealixColors.colorProductSiblings(handles);
      var result = data.result || {};
      var byHandle = {};
      ['core', 'le'].forEach(function(edition) {
        var arr = result[edition];
        if (!Array.isArray(arr)) return;
        arr.forEach(function(item) {
          var v = item.variant;
          if (!v || !v.handle) return;
          var base = item.handle;
          if (!byHandle[base]) byHandle[base] = [];
          var exists = byHandle[base].some(function(e) { return e.handle === v.handle; });
          if (!exists) {
            byHandle[base].push({ handle: v.handle, color: v.color, hash: v.color_code });
          }
        });
      });
      return byHandle;
    } catch(e) { return {}; }
  }

  function parsePriceToCents(val) {
    if (typeof val === 'number') return val > 500 ? val : Math.round(val * 100);
    var f = parseFloat(val);
    if (isNaN(f)) return 0;
    return f > 500 ? Math.round(f) : Math.round(f * 100);
  }

  function imgUrl(src, size) {
    if (!src) return '';
    if (src.indexOf('cdn.shopify.com') > -1) return src.replace(/(\.[^.?]+)(\?|$)/, '_' + size + 'x$1$2');
    return src;
  }

  function buildSizeDropdown(product, firstVariant) {
    var variants = product.variants || [];
    var sizeOptIndex = -1;
    (product.options || []).forEach(function(opt, idx) {
      var name = typeof opt === 'string' ? opt : (opt.name || '');
      if (name.toLowerCase() === 'size') sizeOptIndex = idx;
    });
    if (sizeOptIndex < 0) return '';
    var opts = '';
    var seenSizes = {};
    variants.forEach(function(v) {
      var size = v['option' + (sizeOptIndex + 1)] || '';
      if (!size || seenSizes[size]) return;
      seenSizes[size] = true;
      var sel = v.id === firstVariant.id ? ' selected' : '';
      var dis = !v.available ? ' disabled' : '';
      opts += '<option value="' + v.id + '" data-price="' + v.price + '"' + sel + dis + '>' +
        esc(size) + (!v.available ? ' (Sold out)' : '') + '</option>';
    });
    return '<select class="cu__select cu__size-select" data-upsell-size>' + opts + '</select>';
  }

  function buildColorDropdown(siblings, currentHandle) {
    if (!siblings || siblings.length < 2) return '';
    var currentSibling = null;
    siblings.forEach(function(c) { if (c.handle === currentHandle) currentSibling = c; });
    var currentHash = currentSibling ? currentSibling.hash : '#ccc';
    var opts = '';
    siblings.forEach(function(c) {
      var sel = c.handle === currentHandle ? ' selected' : '';
      opts += '<option value="' + esc(c.handle) + '" data-color-hash="' + esc(c.hash || '#ccc') + '"' + sel + '>' + esc(c.color) + '</option>';
    });
    return '<div class="cu__color-wrap">' +
      '<span class="cu__color-dot" data-color-dot style="background:' + esc(currentHash) + '"></span>' +
      '<select class="cu__select cu__color-select" data-upsell-color>' + opts + '</select>' +
    '</div>';
  }

  function renderCard(product, idx, siblings) {
    if (!product) return '';
    var variants = product.variants || [];
    var hasAny = variants.some(function(v) { return v.available; });
    if (!hasAny) return '';
    var firstImg = product.images && product.images[0];
    var img = firstImg ? (typeof firstImg === 'string' ? firstImg : firstImg.src || '') : '';
    var firstVariant = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) { firstVariant = variants[i]; break; }
    }
    if (!firstVariant) return '';

    var origPrice = parsePriceToCents(firstVariant.price);

    var sizeDD = buildSizeDropdown(product, firstVariant);
    var colorDD = buildColorDropdown(siblings, product.handle);

    return '<div class="cu__card" data-upsell-handle="' + esc(product.handle) + '" data-upsell-idx="' + idx + '">' +
      '<div class="cu__card-check">' +
        '<input type="checkbox" class="cu__checkbox" data-upsell-check checked id="upsell-check-' + idx + '">' +
      '</div>' +
      '<a href="/products/' + esc(product.handle) + '" class="cu__card-img">' +
        '<img src="' + esc(imgUrl(img, '200')) + '" alt="' + esc(product.title) + '" loading="lazy">' +
      '</a>' +
      '<div class="cu__card-body">' +
        '<a href="/products/' + esc(product.handle) + '" class="cu__card-name">' + esc(product.title) + '</a>' +
        '<div class="cu__card-pricing">' +
          '<span class="cu__price-new" data-upsell-sale>' + moneyFmt(origPrice) + '</span>' +
          '<span class="cu__price-old" data-upsell-orig style="display:none">' + moneyFmt(origPrice) + '</span>' +
        '</div>' +
        ((colorDD || sizeDD) ? '<div class="cu__selectors">' + colorDD + sizeDD + '</div>' : '') +
      '</div>' +
    '</div>';
  }

  function updateCardPrice(card, price, discountPct) {
    var cents = parsePriceToCents(price);
    var saleEl = card.querySelector('[data-upsell-sale]');
    var origEl = card.querySelector('[data-upsell-orig]');
    if (discountPct > 0) {
      var disc = Math.round(cents * (100 - discountPct) / 100);
      if (saleEl) saleEl.textContent = moneyFmt(disc);
      if (origEl) { origEl.textContent = moneyFmt(cents); origEl.style.display = ''; }
    } else {
      if (saleEl) saleEl.textContent = moneyFmt(cents);
      if (origEl) origEl.style.display = 'none';
    }
  }

  function getSelectedVariantId(card) {
    var sizeSelect = card.querySelector('[data-upsell-size]');
    if (sizeSelect) {
      var opt = sizeSelect.options[sizeSelect.selectedIndex];
      if (opt && !opt.disabled) return parseInt(sizeSelect.value, 10);
      for (var i = 0; i < sizeSelect.options.length; i++) {
        if (!sizeSelect.options[i].disabled) return parseInt(sizeSelect.options[i].value, 10);
      }
      return 0;
    }
    var product = _cache[card.dataset.upsellHandle];
    if (product && product.variants) {
      for (var j = 0; j < product.variants.length; j++) {
        if (product.variants[j].available) return product.variants[j].id;
      }
    }
    return 0;
  }

  function updateColorDot(card) {
    var colorSelect = card.querySelector('[data-upsell-color]');
    var dot = card.querySelector('[data-color-dot]');
    if (!colorSelect || !dot) return;
    var opt = colorSelect.options[colorSelect.selectedIndex];
    if (opt) dot.style.background = opt.dataset.colorHash || '#ccc';
  }

  function bindCardEvents(container) {
    container.querySelectorAll('.cu__card').forEach(function(card) {
      var sizeSelect = card.querySelector('[data-upsell-size]');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function() {
          var opt = sizeSelect.options[sizeSelect.selectedIndex];
          var root = container.closest('[data-cart-upsell-root]');
          if (root) updateTotals(root);
        });
      }

      var colorSelect = card.querySelector('[data-upsell-color]');
      if (colorSelect) {
        colorSelect.addEventListener('change', function() {
          updateColorDot(card);
          var newHandle = colorSelect.value;
          if (newHandle) switchCardColor(card, newHandle, container);
        });
      }
    });

    bindAddAllButton(container);
  }

  async function switchCardColor(card, newHandle, container) {
    card.classList.add('cu__card--loading');
    var product = await fetchProduct(newHandle);
    if (!product) { card.classList.remove('cu__card--loading'); return; }
    _cache[newHandle] = product;
    card.dataset.upsellHandle = newHandle;

    var imgEl = card.querySelector('.cu__card-img img');
    var firstImg = product.images && product.images[0];
    var src = firstImg ? (typeof firstImg === 'string' ? firstImg : firstImg.src || '') : '';
    if (imgEl && src) imgEl.src = imgUrl(src, '200');

    var nameEl = card.querySelector('.cu__card-name');
    if (nameEl) nameEl.textContent = product.title;

    var firstAvail = null;
    (product.variants || []).forEach(function(v) { if (v.available && !firstAvail) firstAvail = v; });
    var sizeSelect = card.querySelector('[data-upsell-size]');
    if (sizeSelect) {
      var sizeOptIndex = -1;
      (product.options || []).forEach(function(opt, idx) {
        var name = typeof opt === 'string' ? opt : (opt.name || '');
        if (name.toLowerCase() === 'size') sizeOptIndex = idx;
      });
      if (sizeOptIndex > -1) {
        var opts = '';
        var seenSizes = {};
        product.variants.forEach(function(v) {
          var size = v['option' + (sizeOptIndex + 1)] || '';
          if (!size || seenSizes[size]) return;
          seenSizes[size] = true;
          var sel = firstAvail && v.id === firstAvail.id ? ' selected' : '';
          var dis = !v.available ? ' disabled' : '';
          opts += '<option value="' + v.id + '" data-price="' + v.price + '"' + sel + dis + '>' +
            esc(size) + (!v.available ? ' (Sold out)' : '') + '</option>';
        });
        sizeSelect.innerHTML = opts;
      }
    }

    card.classList.remove('cu__card--loading');
    var root = container.closest('[data-cart-upsell-root]');
    if (root) updateTotals(root);
  }

  function bindAddAllButton(container) {
    var root = container.closest('[data-cart-upsell-root]');
    if (!root) return;
    var addAllBtn = root.querySelector('[data-upsell-add-all]');
    if (!addAllBtn) return;

    addAllBtn.onclick = async function() {
      var cards = container.querySelectorAll('.cu__card');
      var items = [];
      cards.forEach(function(card) {
        var check = card.querySelector('[data-upsell-check]');
        if (!check || !check.checked) return;
        var vid = getSelectedVariantId(card);
        if (vid) items.push({ id: vid, quantity: 1 });
      });
      if (items.length === 0) return;

      addAllBtn.disabled = true;
      addAllBtn.textContent = 'Adding...';

      try {
        if (window.CartAPI && window.CartAPI.addItems) {
          await window.CartAPI.addItems(items);
        } else {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        }
        addAllBtn.textContent = 'Added!';
        setTimeout(function() { addAllBtn.textContent = 'Add All to Cart'; addAllBtn.disabled = false; }, 1500);
      } catch(e) {
        addAllBtn.textContent = 'Add All to Cart';
        addAllBtn.disabled = false;
      }
    };
  }

  function getCardOrigPrice(card) {
    var price = 0;
    var sizeSelect = card.querySelector('[data-upsell-size]');
    if (sizeSelect) {
      var opt = sizeSelect.options[sizeSelect.selectedIndex];
      if (opt && !opt.disabled) price = parsePriceToCents(opt.dataset.price);
    } else {
      var prod = _cache[card.dataset.upsellHandle];
      if (prod && prod.variants) {
        for (var i = 0; i < prod.variants.length; i++) {
          if (prod.variants[i].available) { price = parsePriceToCents(prod.variants[i].price); break; }
        }
      }
    }
    return price;
  }

  function updateTotals(root) {
    var totalEl = root.querySelector('[data-upsell-total]');
    var origTotalEl = root.querySelector('[data-upsell-total-orig]');
    var badgeEl = root.querySelector('[data-cu-discount-badge]');
    if (!totalEl) return;

    var cartSubtotal = _cartSubtotalCents;
    var subtotalAttr = root.getAttribute('data-cart-subtotal');
    if (subtotalAttr && !_cartSubtotalCents) cartSubtotal = parseInt(subtotalAttr, 10) || 0;

    var cards = root.querySelectorAll('.cu__card');
    var upsellOrigCents = 0;
    var checkedCards = [];

    cards.forEach(function(card) {
      var check = card.querySelector('[data-upsell-check]');
      if (!check || !check.checked) return;
      var vid = getSelectedVariantId(card);
      if (!vid) return;
      var price = getCardOrigPrice(card);
      upsellOrigCents += price;
      checkedCards.push({ card: card, price: price });
    });

    var projectedTotal = cartSubtotal + upsellOrigCents;
    var discountPct = getDiscountPercent(projectedTotal);

    cards.forEach(function(card) {
      var price = getCardOrigPrice(card);
      updateCardPrice(card, price, discountPct);
    });

    var discountedTotal = 0;
    checkedCards.forEach(function(item) {
      discountedTotal += Math.round(item.price * (100 - discountPct) / 100);
    });

    totalEl.textContent = moneyFmt(discountedTotal);
    if (origTotalEl) {
      origTotalEl.textContent = moneyFmt(upsellOrigCents);
      origTotalEl.style.display = discountPct > 0 ? '' : 'none';
    }

    if (badgeEl) {
      if (discountPct > 0) {
        badgeEl.textContent = discountPct + '% OFF';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }
  }

  function bindTotalListeners(root) {
    root.querySelectorAll('[data-upsell-check]').forEach(function(cb) {
      cb.addEventListener('change', function() { updateTotals(root); });
    });
    root.querySelectorAll('[data-upsell-size]').forEach(function(sel) {
      sel.addEventListener('change', function() { updateTotals(root); });
    });
    updateTotals(root);
  }

  async function tier3(cartHandles, exclude) {
    var handles = [];
    var usedCols = {};
    exclude.forEach(function(h) { usedCols[h] = true; });
    var cols = FALLBACK_COLLECTIONS.filter(function(c) { return !usedCols[c]; });
    var promises = cols.map(function(col) {
      return fetchJSON('/collections/' + encodeURIComponent(col) + '/products.json?limit=4&sort_by=best-selling')
        .then(function(data) {
          (data.products || []).forEach(function(p) {
            var hasAvail = (p.variants || []).some(function(v) { return v.available; });
            if (hasAvail && p.handle && !cartHandles[p.handle]) {
              handles.push(p.handle);
              _cache[p.handle] = p;
            }
          });
        }).catch(function() {});
    });
    await Promise.all(promises);
    return handles;
  }

  function dedupeProducts(fetched, existing, maxTotal) {
    var products = [].concat(existing);
    var seenTitles = {};
    var seenHandles = {};
    products.forEach(function(p) {
      seenTitles[(p.title || '').replace(/\s*[-\u2013]\s*.+$/, '').trim()] = true;
      seenHandles[p.handle] = true;
    });
    for (var i = 0; i < fetched.length && products.length < maxTotal; i++) {
      var p = fetched[i];
      if (!p || seenHandles[p.handle]) continue;
      var hasAvail = (p.variants || []).some(function(v) { return v.available; });
      if (!hasAvail) continue;
      var baseTitle = (p.title || '').replace(/\s*[-\u2013]\s*.+$/, '').trim();
      if (seenTitles[baseTitle]) continue;
      seenTitles[baseTitle] = true;
      seenHandles[p.handle] = true;
      products.push(p);
    }
    return products;
  }

  async function runUpsellEngine(opts) {
    if (_running) return;
    _running = true;
    var isRefresh = opts && opts.refresh;

    var roots = getAllRoots();
    var containers = getAllContainers();

    if (roots.length === 0) { _running = false; return; }

    try {
      var cartData = await fetchJSON('/cart.js');
      _cartSubtotalCents = cartData.items_subtotal_price || 0;
      var items = cartData.items || [];
      if (items.length === 0) {
        roots.forEach(function(r) { r.hidden = true; });
        _renderedHTML = '';
        _running = false;
        return;
      }

      var cartToken = items.map(function(i) { return i.handle + ':' + i.variant_id; }).sort().join('|');
      if (cartToken === _lastCartToken && _renderedHTML) {
        applyRenderedHTML();
        _running = false;
        return;
      }

      if (isRefresh) showSkeleton();

      var cartHandles = {};
      var skus = [];
      var productTypes = [];

      items.forEach(function(item) {
        cartHandles[item.handle] = true;
        if (item.sku) skus.push(item.sku);
        if (item.product_type && productTypes.indexOf(item.product_type) === -1)
          productTypes.push(item.product_type);
      });

      var products = [];
      var t2UsedCols = [];

      // Tier 1: Swatch linked products (by cart product handle)
      var t1Handles = await tier1(Object.keys(cartHandles));
      if (t1Handles.length) {
        var unique = [];
        t1Handles.forEach(function(h) { if (!cartHandles[h] && unique.indexOf(h) === -1) unique.push(h); });
        var fetched = await Promise.all(unique.slice(0, MAX_CARDS + 4).map(fetchProduct));
        products = dedupeProducts(fetched, products, MAX_CARDS);
      }

      // Tier 2: Cross-sell map collections (only if still need more)
      if (products.length < MIN_CARDS) {
        var colSet = {};
        productTypes.forEach(function(pt) {
          var targets = CROSSSELL_MAP[pt];
          if (!targets) return;
          targets.forEach(function(col) { if (!colSet[col]) { colSet[col] = true; t2UsedCols.push(col); } });
        });
        var t2Handles = await tier2(productTypes);
        if (t2Handles.length) {
          var unique2 = [];
          t2Handles.forEach(function(h) { if (!cartHandles[h] && unique2.indexOf(h) === -1) unique2.push(h); });
          var fetched2 = await Promise.all(unique2.slice(0, MAX_CARDS + 4).map(fetchProduct));
          products = dedupeProducts(fetched2, products, MAX_CARDS);
        }
      }

      // Tier 3: Fallback best-sellers from broad collections (only if still need more)
      if (products.length < MIN_CARDS) {
        var t3Handles = await tier3(cartHandles, t2UsedCols);
        if (t3Handles.length) {
          var unique3 = [];
          t3Handles.forEach(function(h) { if (unique3.indexOf(h) === -1) unique3.push(h); });
          var fetched3 = await Promise.all(unique3.slice(0, MAX_CARDS + 4).map(fetchProduct));
          products = dedupeProducts(fetched3, products, MAX_CARDS);
        }
      }

      if (products.length === 0) {
        roots.forEach(function(r) { r.hidden = true; });
        containers.forEach(function(c) { c.innerHTML = ''; });
        _renderedHTML = '';
        _running = false;
        return;
      }

      var siblingMap = await fetchColorSiblings(products.map(function(p) { return p.handle; }));

      var html = '';
      products.forEach(function(p, idx) {
        var baseHandle = p.handle.replace(/-[^-]+$/, '');
        var siblings = siblingMap[baseHandle] || [];
        html += renderCard(p, idx, siblings);
      });

      _renderedHTML = html;
      _renderedProducts = products;
      _renderedSiblings = siblingMap;
      _lastCartToken = cartToken;

      containers.forEach(function(c) {
        c.innerHTML = html;
        bindCardEvents(c);
      });
      roots.forEach(function(r) {
        r.hidden = false;
        showFooter();
        bindTotalListeners(r);
      });

    } catch(e) {
      console.warn('Cart upsell engine error:', e);
    }

    _running = false;
  }

  var debounceTimer;
  function debouncedRun(isRefresh) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() { runUpsellEngine({ refresh: isRefresh }); }, 50);
  }

  window.addEventListener('cart:updated', function() { debouncedRun(true); });
  window.addEventListener('cart:item-added', function() { debouncedRun(true); });

  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType === 1 && (node.hasAttribute && node.hasAttribute('data-cart-upsell-root') ||
            node.querySelector && node.querySelector('[data-cart-upsell-root]'))) {
          if (_renderedHTML) {
            applyRenderedHTML();
          } else {
            showSkeleton();
            debouncedRun(false);
          }
          return;
        }
      }
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

  debouncedRun(false);
})();
